var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.458 3.129L27.4085 5.6595C26.9405 4.03278 25.9574 2.60176 24.6068 1.58129C23.2563 0.560819 21.6112 0.00595565 19.9185 0H7.798C5.73155 0.0055426 3.75131 0.828895 2.2901 2.2901C0.828895 3.75131 0.0055426 5.73155 0 7.798L0 14.84C0.0055426 16.9065 0.828895 18.8867 2.2901 20.3479C3.75131 21.8091 5.73155 22.6325 7.798 22.638H19.9185C21.6108 22.6323 23.2555 22.0779 24.606 21.0581C25.9565 20.0383 26.9398 18.6081 27.4085 16.982L31.458 19.509C33.4075 20.727 35 19.859 35 17.5455V5.0925C35 2.793 33.4075 1.911 31.458 3.129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.bb5c4b94702552d868fdf247f581917d.svg";
export { ForwardRef as ReactComponent };